import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { addCache } from 'api/caching'
import { OrgAccountStatus, Organization, OrganizationInvitation } from 'types'

import { unscopedApiClient } from '../../unscopedApiClient'
import { getCerebroHeaders } from '../headers'
import { CerebroApiOptions } from '../types'

export const getOrganization = (
    organizationId: string | number
): Promise<AxiosResponse<Organization>> =>
    unscopedApiClient.get(`api/organization/${organizationId}/`, {
        validateStatus: (status) => status < 300,
    })
addCache(getOrganization)

export const getOrganizationAccountStatus = (
    organizationId: string | number,
    options: CerebroApiOptions = {}
): Promise<AxiosResponse<OrgAccountStatus>> =>
    unscopedApiClient.get(
        `api/organization/${organizationId}/account_status/`,
        {
            headers: getCerebroHeaders(options.headers),
        }
    )

export const getInvitations = (
    params: AxiosRequestConfig
): Promise<AxiosResponse<OrganizationInvitation[]>> =>
    unscopedApiClient.get('/api/invitations/', { params })
addCache(getInvitations)

export const patchInvitation = (
    invitationId: number,
    params: AxiosRequestConfig
): Promise<AxiosResponse<OrganizationInvitation>> =>
    unscopedApiClient.patch(`/api/invitation/${invitationId}/`, params)
